import { atom } from 'jotai';

/** True while onboarding modal onSubmit is in progress (org survey submit). Used to block trial modals until onboarding submit fully completes. */
export const isOnboardingSubmitInProgressAtom = atom(false);
